module.exports = __webpack_public_path__ + "img/20210211_094738.3961b8e9.jpg";